import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, FileText } from 'lucide-react';

// Sticky call / quote bar, visible on phones only (see .mobile-cta in ProClimb.css)
const MobileCTA = () => (
  <div className="mobile-cta">
    <a href="tel:0426920301" className="call" aria-label="Call ProClimb Solutions">
      <Phone size={18} aria-hidden="true" /> Call Now
    </a>
    <Link to="/contact#quote-form" className="quote">
      <FileText size={18} aria-hidden="true" /> Get a Quote
    </Link>
  </div>
);

export default MobileCTA;
